import React, { Component } from "react";
import ReactDOM from 'react-dom';


class TYItem extends Component{
    constructor(props){
        super(props);

        this.toggleActions = this.toggleActions.bind(this);
        this.handleDocClick = this.handleDocClick.bind(this);

        this.state = {
            actions_toggled: false
        };
    }

    componentDidMount() {
        // add event listener for clicks
        document.addEventListener('click', this.handleDocClick, false);
    }

    componentWillUnmount() {
        // make sure you remove the listener when the component is destroyed
        document.removeEventListener('click', this.handleDocClick, false);
    }

    handleDocClick(e){
        if(!ReactDOM.findDOMNode(this).contains(e.target)) {
            if(this.state.actions_toggled)
                this.setState({actions_toggled: false});
        }
    }

    toggleActions(){
        this.setState({actions_toggled: !this.state.actions_toggled});
    }

    render(){
        let classesAddon = "";
        if(this.props.icon && this.props.actions.length)
            classesAddon = "min-100";
        else if(this.props.icon || this.props.actions.length)
            classesAddon = "min-50";

        return (
            <div
                className={
                    "ty-item " + (this.props.flagColor !== false ? "border-l-5-" + this.props.flagColor + "-important" : "")
                    + " " + this.props.className + " bg-" + this.props.backgroundColor
                }
                style={
                    this.props.flagColorCode ? {
                        borderLeftColor: this.props.flagColorCode,
                        borderLeftWidth: 5
                    } : null
                }
            >
                <div className="d-flex">
                    {
                        this.props.icon !== false ?
                            <div className="ty-item-icon">
                                <i className={`${this.props.icon} icon-lg`} aria-hidden="true"> </i>
                            </div>
                            :
                            null
                    }

                    <div className={"ty-item-content " + classesAddon}>{ this.props.children }</div>

                    { this.props.postContent }

                    {
                                this.props.actions.length ?
                                    <div className="ty-item-actions">
                                        <div className="ty-item-caret" onClick={this.toggleActions}>
                                            <i className={"icon icon-chevron-" + (this.state.actions_toggled ? "up" : "down")} aria-hidden="true"> </i>
                                        </div>
                                    </div>
                                    :
                                    this.props.action.icon ?
                                        <div className="ty-item-actions">
                                            <div
                                                className={"ty-item-caret " + this.props.action.colorHover + "-hover bg-" + this.props.action.backgroundColorHover + "-hover-important"}
                                                onClick={this.props.action.onclick}>
                                                <i className={this.props.action.icon} aria-hidden="true"> </i>
                                            </div>
                                        </div>
                                        :
                                        null
                            }
                </div>

                {
                    this.props.actions.length && this.state.actions_toggled ?
                        <ul className="ty-item-actions-list">
                            {
                                this.props.actions.map((action, i) => {
                                    return <li
                                        key={i}
                                        className="ty-item-action"
                                        onClick={action.onclick}>
                                        { action.label }
                                    </li>;
                                })
                            }
                        </ul>
                        :
                        ""
                }

            </div>
        );
    }
}

TYItem.defaultProps = {
    content: "",
    icon: false,
    actions: [],
    action: {
        icon: false,
        backgroundColorHover: "gray",
        colorHover: "blue_dark",
        onclick: () => {}
    },
    flagColor: false,
    flagColorCode: false,
    backgroundColor: "white",
    className: "",
    postContent: undefined
};

export default TYItem;



// WEBPACK FOOTER //
// ./src/components/TYItem.js